import React from "react";

// Components
import Button from "../../utils/Button";

class TitleBar extends React.PureComponent {
	render() {
		return (
			<div className={`title-bar` + (!!this.props.button ? `title-bar--with-button` : ``)}>
				<h2>{this.props.children}</h2>
				{!!this.props.button && (
					<Button
						text={this.props.button.text}
						clickHandler={this.props.button.action}
						isLoading={this.props.button.inProcess}
					/>
				)}
			</div>
		);
	}
}

export default TitleBar;



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/TitleBar.js